export default __webpack_public_path__ + "static/media/ovlBg.1197a96d.svg";